import { connect } from 'react-redux';
import { actions } from "../../../../redux/modules/gastos/gastos";
import DetalleGasto from './DetalleGasto';


const ms2p = (state) => {
    return {
        ...state.gastos,
        sucursal: state.usuario.sucursal,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(DetalleGasto);
